import React from "react";

import Label from "./Label";

import styles from "./Field.module.scss";

const Field = React.forwardRef(
  (
    {
      className,
      defaultValue,
      description,
      disabled,
      errors,
      id,
      isRequired,
      label,
      placeholder,
      type,
      onChange,
      inputProps = {},
    },
    ref
  ) => {
    const isInvalid = errors[id] ? "is-invalid" : "";

    return (
      <div className={`${styles.formGroup} ${className}`}>
        <Label id={id} label={label} isRequired={isRequired} />
        <input
          id={id}
          className={`${styles.field} form-control ${isInvalid}`}
          defaultValue={defaultValue}
          disabled={!!disabled}
          name={id}
          placeholder={placeholder}
          ref={ref}
          type={type}
          onChange={onChange}
          {...inputProps}
        />
        <span className={`${styles.description} d-block mt-3`}>{description}</span>
        {errors[id] && (
          <div className="invalid-feedback">
            {errors[id].type === "validate" ? "Invalid format or value" : "This field is required."}
          </div>
        )}
      </div>
    );
  }
);

export default Field;
